import React from 'react';
import styles from './StatusFilter.module.scss';

export type StatusOption<TValue extends string> = {
    value: TValue;
    label: string;
};

type StatusFilterProps<TValue extends string> = {
    options: StatusOption<TValue>[];
    value: TValue;
    onChange: (value: TValue) => void;
    ariaLabel: string;
};

/**
 * Segmented control for switching a list between mutually exclusive states, as the
 * Nature Risk site list does between Active, Draft and Archived.
 */
const StatusFilter = <TValue extends string>({ options, value, onChange, ariaLabel }: StatusFilterProps<TValue>) => (
    <div className={styles.filterGroup} role='group' aria-label={ariaLabel}>
        {options.map(option => {
            const isSelected = value === option.value;
            return (
                <button
                    key={option.value}
                    type='button'
                    aria-pressed={isSelected}
                    className={`${styles.filterButton} ${isSelected ? styles.selected : ''}`}
                    data-selected={isSelected || undefined}
                    onClick={() => {
                        if (!isSelected) {
                            onChange(option.value);
                        }
                    }}
                >
                    {option.label}
                </button>
            );
        })}
    </div>
);

export default StatusFilter;
